
import { uuidv4 } from "../../lib/utils";
import { CartContext } from '../../providers/CartContext';
import useTranslations from "../../providers/useTranslations";

import PopUpComponent from "../../components/popupComponent";
import MessageModal from '../components/modals/MessageModal';

import ServiceAddons from './service_addons'
import ServiceOptions from './service_options'


export default function Service(props) {
  const { onClose, optionsFirst, hasOrdering, value, formatPrice,
    increment, decrement, getDisplayedBasePrice,
    setDisplayTotal, categories, isOffer } = props;
  const { getProductCost, getItemTotalCost } = React.useContext(CartContext);

  const [service, setService] =React.useState({})
  const [displayPrice, setDisplayPrice] =React.useState(props.service.price)
  const [showMessageModal, setShowMessageModal] =React.useState(false)

  const forceUpdate = React.useReducer(() => ({}), {})[1]

  const { tr } = useTranslations();

  const increaseAddon = (addon) => {
    let selectedAddons = service.selectedAddons || []

    if (service.maxAddons && service.maxAddons > 0) {
      let sum = selectedAddons.reduce((sum, a) => sum + a.quantity, 0)
      if (sum >= service.maxAddons) {
        return
      }
    }

    let found = selectedAddons.find((a) => a.name === addon.name)

    if (found !== undefined) {
      if (found.max === 1) {
        return
      } else {
        found.quantity = (found.quantity || 0) + 1
      }
    } else {
      let newAddon = Object.assign({}, addon)
      newAddon.quantity = 1
      selectedAddons.push(newAddon)
      service.selectedAddons = selectedAddons
    }

    let serviceCost = getProductCost(service)
    setDisplayPrice(serviceCost)

    let dispTotal = getItemTotalCost(service)
    setDisplayTotal(dispTotal, service)

    forceUpdate()
  }

  const decreaseAddon = (addon) => {
    let selectedAddons = service.selectedAddons || []

    let found = selectedAddons.find((a) => a.name === addon.name)

    if (found !== undefined) {
      found.quantity = found.quantity - 1
    }

    if (found.quantity === 0) {
      service.selectedAddons = selectedAddons.filter((a) => a.name !== addon.name)
    }

    let serviceCost = getProductCost(service)
    setDisplayPrice(serviceCost)

    let dispTotal = getItemTotalCost(service)
    setDisplayTotal(dispTotal, service)

    forceUpdate()
  }

  const optionSelected = (option, group) => {
    let selectedOptions = service.selectedOptions || []

    let found = selectedOptions.find((o) => o.id == option.id)

    if (found) {
      selectedOptions = selectedOptions.filter((a) => a.id !== option.id)
    } else {
      if (group.mutex && selectedOptions.length > 0) {
        selectedOptions = selectedOptions.filter((a) => a.group_name !== option.group_name)
      }
      selectedOptions.push(option)
    }
    service.selectedOptions = selectedOptions

    let serviceCost = getProductCost(service)
    setDisplayPrice(serviceCost)

    let dispTotal = getItemTotalCost(service)
    setDisplayTotal(dispTotal, service)

    forceUpdate()
  }

  const _allMandataryOptionsSelected = () => {
    let selectedOptions = service.selectedOptions || []

    if (!service.OptionGroups || service.OptionGroups.length === 0)
      return true

    const groups = service.OptionGroups

    for (let i = 0; i < groups.length; i++) {
      let group = groups[i]
      let options = group.Options.filter((opt) => opt.available === true)

      if (group.mandatory && options.length > 0) {
        let found = selectedOptions.find((a) => a.group_id === group.id)
        if (!found) return false
      }
    }
    return true
  }

 React.useEffect(() => {
    let serv = Object.assign({}, props.service)
    setService(serv)
    setDisplayPrice(serv.price)

  }, [props.service])

  const _statusSection = (message) => {
    return (<div className="centered" style={{
      marginLeft: 20,
      marginRight: 20,
      color: props.detailColour || 'red'
    }}>
      {message}
    </div>)
  }

  const optionsAndAddons = () => {
    if (optionsFirst) {
      return (
        <div>

          <ServiceOptions className="service-options" service={service}
            detailColour={props.detailColour}
            darkMode={props.darkMode}
            ordersAvailable={props.ordersAvailable}
            onSelected={optionSelected}
            formatPrice={formatPrice}
          />

          {service.Options && service.Options.length > 0 && <hr />}

          <ServiceAddons className="service-addons" service={service}
            detailColour={props.detailColour}
            darkMode={props.darkMode}
            ordersAvailable={props.ordersAvailable}
            onIncrease={increaseAddon}
            onDecrease={decreaseAddon}
            formatPrice={formatPrice}
          />

        </div>
      )
    }

    return (
      <div>

        <ServiceAddons className="service-addons" service={service}
          detailColour={props.detailColour}
          darkMode={props.darkMode}
          ordersAvailable={props.ordersAvailable}
          onIncrease={increaseAddon}
          onDecrease={decreaseAddon}
          formatPrice={formatPrice}
        />

        <ServiceOptions className="service-options" service={service}
          detailColour={props.detailColour}
          darkMode={props.darkMode}
          ordersAvailable={props.ordersAvailable}
          onSelected={optionSelected}
          formatPrice={formatPrice}
        />
      </div>
    )
  }

  const formatDuration = (minutes) => {
    if (!minutes) return "";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) {
      return `${hours}h ${mins > 0 ? mins + 'm' : ''}`;
    }
    return `${mins}m`;
  }

  function ServiceInfo(props) {
    const { service, price } = props

    return (
      <div className="service-detail" >

        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-12 description">
            {service.description}
          </div>
        </div>

        {service.duration && (
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-12">
              <span className="text-gray">
                <i className="icofont-clock-time"></i> Duration: {formatDuration(service.duration)}
              </span>
            </div>
          </div>
        )}

        {service.type && (
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-12">
              <span className="badge badge-secondary">{service.type}</span>
            </div>
          </div>
        )}

      </div>

    )
  }

  function ServiceOrderButton(props) {
    const { service, price, onClose, detailColour } = props

    const [comments, setComments] =React.useState(null)

    const { addItemToCart } = React.useContext(CartContext);

    const [amount, setAmount] =React.useState(1)

    const addToCart = () => {

      if (isOffer) {
        setShowMessageModal(true)
        return
      }

      if (!hasOrdering) {
        alert(tr("This business cannot take orders at the moment, please check back later"))
        return
      }

      if (!_allMandataryOptionsSelected()) {
        alert(tr("Please select all mandatory options"))
        return
      }

      let newItem = Object.assign({}, service);
      newItem.quantity = value
      newItem.comments = comments
      newItem.uuid = uuidv4()
      let args = { id: newItem.id, quantity: 1 }
      addItemToCart(newItem, args);
      onClose()
    }

    return (
      <div>
        <div className="service-info">

          <div className="">
            <h6>
              Comentarios
            </h6>
            <textarea name="comments" id="order_comments"

              style={{
                width: '90%'
              }}
              onChange={(e) => {
                setComments(e.target.value)
              }}
            >
            </textarea>
          </div>
        </div>

        <div className="service-total" style={{ margin: "10px" }}>

        </div>


        <div className=" service-total">
          <div className="add-item-button btn-success"
            onClick={addToCart}
            style={{
              backgroundColor: detailColour,
            }}
          >
            <span style={{
              color: 'white'
            }}><i className='fa fa-shopping-cart'></i>
            </span>
            <span>{tr("Add to Cart")}</span>
            <span></span>
          </div>
        </div>

      </div>
    )
  }

  const configs = service.Configs || []
  const statusMessage = configs.find((cfg) => cfg.name === 'statusMessage' && cfg.model === 'service')

  return (

    <div className="service-details">

      <ServiceInfo service={service}
        detailColour={props.detailColour}
        darkMode={props.darkMode}
        price={getProductCost(service)}
      />

      {optionsAndAddons()}

      <ServiceOrderButton service={service} price={displayPrice} onClose={onClose} detailColour={props.detailColour} />

      {statusMessage &&
        <div >
          {_statusSection(statusMessage.value)}
        </div>
      }


      <PopUpComponent title={tr("Special offers are restricted")}
        isVisible={showMessageModal}
        setVisible={showMessageModal}
        showHeader={true}
        onHide={() => {
          setShowMessageModal(false)
         }}
        callback={() => {
          setShowMessageModal(false)
          window.open("https://fbh.zono.cc/1YMJ", "_blank")
        }}
      >
        <div className="d-flex justify-content-center" style={{
          fontSize: 48
        }}>
          <i className="text-success icofont-star"></i>
        </div>

        <div className="d-flex justify-content-center m-4 "
          style={{
            fontSize: 40,
            fontWeight: 'bold'
          }}
        >{tr("Offers")}</div>

        <div className='d-flex text-center justify-content-center'>
          {tr("This service can only be ordered via the XooNoo mobile app")}
        </div>

        <div className='d-flex text-center justify-content-center'>
          {tr("Download now")}!!
        </div>

        <div className="row mt-4 show-only-small-devices">
          <a href="https://fbh.zono.cc/1YMJ" target="_blank">
            <div className="col-6" >
              <div className="mt-1 centered">
                <img src="/images/google-play-badge.png" style={{ width: 150 }}></img>
              </div>

            </div>
          </a>
        </div>


      </PopUpComponent>


    </div>
  )
}
